export const SET_COMPANY_LOADER = 'SET_COMPANY_LOADER';